{
  "version": 1,
  "asset_id": "73452d8f-de38-4db2-83a0-03a13b2b6d88",
  "project_id": "2403328b-3c44-4450-9753-99d0f792c94f",
  "url": "/__l5e/assets-v1/73452d8f-de38-4db2-83a0-03a13b2b6d88/goh-logo.png",
  "r2_key": "a/v1/2403328b-3c44-4450-9753-99d0f792c94f/73452d8f-de38-4db2-83a0-03a13b2b6d88/goh-logo.png",
  "original_filename": "goh-logo.png",
  "size": 757566,
  "content_type": "image/png",
  "created_at": "2026-07-21T11:55:16Z"
}
